import { useEffect, useRef, useState } from 'react';
import { cloneDeep, isEqual } from 'lodash';
import { ReplicationData, replicationsData$ } from '../rxdb.replication';

function useReplicationInfo(identifier: string): ReplicationData['info'] | null {
  const prevInfo = useRef<ReplicationData['info'] | null>(null);
  const [replicationInfo, setReplicationInfo] = useState<ReplicationData['info'] | null>(null);

  useEffect(() => {
    const subscription = replicationsData$.subscribe(replicationsData => {
      const info = replicationsData[identifier]?.info ?? null;
      if (isEqual(info, prevInfo.current)) {
        return;
      }

      const clonedInfo = info ? cloneDeep(info) : null;

      prevInfo.current = clonedInfo;
      setReplicationInfo(clonedInfo);
    });

    return () => {
      subscription.unsubscribe();
    };
  }, [identifier]);

  return replicationInfo;
}

export default useReplicationInfo;
